/**
 * Bloque de acción de una respuesta (GEN-EKB-027, mockup A-despacho-conversacion): Jimmy confirma el KB de destino con
 * botones dentro de la conversación. El kernel no emite un evento aparte: el bloque viaja en el propio texto,
 *
 *   :::accion
 *   Confirmar el KB de destino
 *   - Sí, en Proveedores
 *   - Mejor en Personas
 *   :::
 *
 * y el Pórtico lo separa del texto y lo pinta. Pulsar una opción envía esa opción como mensaje de la persona.
 * Mientras la respuesta llega por trozos el bloque aún no está cerrado: no se pinta hasta que lo está.
 */
const RE_BLOQUE = /^:::accion[ \t]*\n([\s\S]*?)\n:::[ \t]*$/m

/** { texto, accion } — `accion` es { titulo, opciones[] } o null si no hay un bloque completo con al menos una opción. */
export function separarAccion(markdown) {
  const m = RE_BLOQUE.exec(markdown ?? '')
  if (!m) return { texto: markdown ?? '', accion: null }
  const lineas = m[1].split('\n').map(l => l.trim()).filter(Boolean)
  const opciones = lineas.filter(l => /^[-*] /.test(l)).map(l => l.slice(2).trim()).filter(Boolean)
  const titulo = lineas.find(l => !/^[-*] /.test(l)) ?? 'Confirmar'
  const texto = (markdown.slice(0, m.index) + markdown.slice(m.index + m[0].length)).trim()
  return opciones.length ? { texto, accion: { titulo, opciones } } : { texto: markdown, accion: null }
}
